import axios from '../../../../shared/axios/axios';

import * as actionTypes from '../constants/actionTypes';

export const getEndorsements = (pageRequest) => {
  const url = `/endorsements-pipelines/get-endorsements`;

  return axios
    .post(url, pageRequest)
    .then((response) => (response ? response.data : null))
    .catch((err) => console.log(err));
};

const getEndorsementStatusesStart = () => {
  return {
    type: actionTypes.GET_ENDORSEMENT_STATUSES_START,
  };
};

const getEndorsementStatusesSuccess = (data) => {
  return {
    type: actionTypes.GET_ENDORSEMENT_STATUSES_SUCCESS,
    endorsementStatuses: data,
  };
};

const getEndorsementStatusesFail = (error) => {
  return {
    type: actionTypes.GET_ENDORSEMENT_STATUSES_FAIL,
    error: error,
  };
};

export const getEndorsementStatuses = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getEndorsementStatusesStart());
      const url = `/endorsements-pipelines/get-endorsement-statuses`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getEndorsementStatusesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getEndorsementStatusesFail(err));
          reject();
        });
    });
  };
};

const changeEndorsementStatusStart = () => {
  return {
    type: actionTypes.CHANGE_ENDORSEMENT_STATUS_START,
  };
};

const changeEndorsementStatusSuccess = () => {
  return {
    type: actionTypes.CHANGE_ENDORSEMENT_STATUS_SUCCESS,
  };
};

const changeEndorsementStatusFail = (error) => {
  return {
    type: actionTypes.CHANGE_ENDORSEMENT_STATUS_FAIL,
    error: error,
  };
};

export const changeEndorsementStatus = (formData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(changeEndorsementStatusStart());
      const url = `/endorsements-pipelines/change-status`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(changeEndorsementStatusSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeEndorsementStatusFail(err));
          reject(err);
        });
    });
  };
};

const getEndorsementPipelinesControlConfigStart = () => {
  return {
    type: actionTypes.GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_START,
  };
};

const getEndorsementPipelinesControlConfigSuccess = (data) => {
  return {
    type: actionTypes.GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_SUCCESS,
    endorsementPipelinesControlConfig: data,
  };
};

const getEndorsementPipelinesControlConfigFail = (error) => {
  return {
    type: actionTypes.GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const getEndorsementPipelinesControlConfig = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getEndorsementPipelinesControlConfigStart());
      const url = `/endorsements-pipelines/get-endorsements-pipelines-control-configuration`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getEndorsementPipelinesControlConfigSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getEndorsementPipelinesControlConfigFail(err));
          reject(err);
        });
    });
  };
};
